// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"4123badb","153":"1c05150b","530":"ddbf39c8"}[chunkId] + ".chunk.css";
};